import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { FloatMessageProvider } from './components/Providers/FloatMessage'
import * as serviceWorker from './registerServiceWorker'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <FloatMessageProvider>
      <App />
    </FloatMessageProvider>
  </React.StrictMode>
)

// Registro del Service Worker en producción con soporte para actualizaciones en caliente (modo degradado)
serviceWorker.register((registration) => {
  const waitingWorker = registration.waiting;
  if (waitingWorker) {
    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  }
});

// Listener para recargar la página inmediatamente cuando el Service Worker cambie (actualización silenciosa)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}